import { type RequestPolicy } from 'urql';

import { useIsLoggedIn } from '../../context/AuthMachine';
import { useLoyaltyProfileIdQuery } from './graphql/LoyaltyProfileId.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useLoyaltyProfileId = (params?: Params) => {
  const isLoggedIn = useIsLoggedIn();

  const [response] = useLoyaltyProfileIdQuery({
    pause: !isLoggedIn,
    requestPolicy: params?.requestPolicy ?? 'cache-first',
  });

  return response.data?.loyaltyProfile?.loyaltyId ?? null;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  requestPolicy: RequestPolicy;
};
